import React from 'react'
import styled from 'styled-components'
import { TOPBAR_HEIGHT } from './TopBar'
import AppContainer from './AppContainer'
import BannerComponent from './BannerComponent'
import MainSideBar from './MainSideBar'
import { SIDEBAR_WIDTH } from './SideBar'
import useAppState from '../hooks/useAppState'

const Page = ({ children, ...props }) => {
    const { bannerToDisplay } = useAppState()

    return (
        <AppContainer {...props}>
            <MainSideBar />
            <PageMainContainer>
                {bannerToDisplay && bannerToDisplay.length > 0 && (
                    <BannerComponent bannerContent={bannerToDisplay} />
                )}
                {children}
            </PageMainContainer>
        </AppContainer>
    )
}
export const PageMainContainer = styled.main(
    ({ theme }) => `
    width: 100%;
    margin-top: ${TOPBAR_HEIGHT}rem;
    margin-left: ${SIDEBAR_WIDTH}rem;
    background-color: ${theme.colorGreyLightest};
`,
)

export default Page
